'use client';

import { createInstance, OptimizelyDecideOption } from '@optimizely/react-sdk';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useCacheKey } from './useCacheKey';
import { getENV } from '../utils';

export function useOptimizely(eventName: string) {
    const { cookies } = useCacheKey();
    const decisionsString = cookies.get('x-petm-decisions') ?? '{}';
    const decisions = JSON.parse(decisionsString);
    const optimizely = createInstance({
        sdkKey: getENV('NEXT_PUBLIC_OPTIMIZELY_SDK_KEY'),
        defaultDecideOptions: [OptimizelyDecideOption.DISABLE_DECISION_EVENT],
    });
    useEffect(() => {
        const userId = Cookies.get('x-petm-visitor-id');
        const userContext = optimizely.client?.createUserContext(userId);
        userContext?.decideAll();
        if (decisions?.product_sort) {
            userContext?.trackEvent(eventName);
        }
    }, []);
}
